/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { IDropdownOption } from '@fluentui/react/lib/Dropdown';
import { Label } from '@fluentui/react/lib/Label';
import { Stack } from '@fluentui/react/lib/Stack';
import React from 'react';
import { CalloutButton } from 'src/core/components/CalloutButton';
import { LuisDropdown } from 'src/core/components/LuisDropdown';
import { TryoutModelVersion } from 'src/languageStudio/appShell/prebuiltDemos/utils/supportedModelVerion';

type VersionsDropDownListProps = {
    versionName: string;
    toolTipContent: string;
    chosenVersion: TryoutModelVersion;
    versionOptions: IDropdownOption[];
    setVersion: (optionKey: TryoutModelVersion) => void;
};

export const VersionsDropDownList = (props: VersionsDropDownListProps) => {
    const { versionName, versionOptions, chosenVersion, toolTipContent, setVersion } = props;

    return (
        <Stack horizontal verticalAlign="center">
            <Stack styles={{ root: { width: '250px' } }} verticalAlign="center" horizontal>
                <Label>{versionName}</Label>
                <CalloutButton content={toolTipContent} />
            </Stack>

            <LuisDropdown
                options={versionOptions}
                styles={{ root: { width: 239 } }}
                isSearchEnabled={false}
                selectedKey={chosenVersion}
                onChange={(_, version) => setVersion(version.key as TryoutModelVersion)}
            />
        </Stack>
    );
};
